import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, Box, Grid, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import ButtonAction from '../Button.js/SaveButton';
import ChessBoard from '../ChessBoard/ChessBoard';
import ComboboxImageNameOrQR from '../Input/ComboboxImageNameOrQR';
import NumberInput from '../Input/NumberInput';
import Loader from '../loader/loader';
import ConfirmDeviceModal from './ConfirmDeviceModal';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const StyledProductImg = styled('img')({
    // top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    // position: 'absolute',
});
const CellModal = ({
    idDrawer,
    idCabinet,
    isReload = true,
    visible = false,
    dataUpdate,
    setVisible,
    fuctGet,
    idPermission,
    isQRCodeDevice = false,
    typeCabinet,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);
    const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [name, setName] = useState({});
    const [Max, setMax] = useState('0');
    const [visibleConfirm, setVisibleConfirm] = useState(false);
    const [Min, setMin] = useState('');
    const [deviceCD, setDeviceCD] = useState('');
    const [cabinetCD, setCabinetCD] = useState('');

    const params = useParams();
    const [quantity, setQuantity] = useState('');

    const [actionDeviceOnline, setActionDeviceOnline] = useState(false);
    const actionRef = useRef();
    const [openCellFlag, setOpenCellFlag] = useState(true);
    const dataProcessIOT = useRef([]);

    useEffect(() => {
        setDeviceCD(dataUpdate.device_cd);
        setCabinetCD(dataUpdate.cabinet_cd);
        setMax(dataUpdate.max_no);
        setQuantity('');
        setMin(dataUpdate.min_no);
        setName({
            id: dataUpdate.device_id,
            pic_device: dataUpdate.pic_device,
            img_device: dataUpdate.img_device,
            device_nm: dataUpdate.device_nm,
            device_cd: dataUpdate.device_cd,
        });
    }, [dataUpdate]);

    useEffect(() => {
        if (visible) openCell(dataUpdate);
        return () => {
            clearIntervalCheckStatusCell();
        };
    }, [visible]);

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, []);

    // region openCell
    const openCell = (data) => {
        console.log('openCell', data);

        if (!data?.cell_lc) return;
        if (actionRef.current) return;
        setActionDeviceOnline(true);
        setOpenCellFlag(true);
        actionRef.current = true;
        dataProcessIOT.current = [
            +idPermission,
            dataUpdate.cabinet_id,
            dataUpdate.drawer_id,
            '',
            +Max,
            +Min,
            +quantity,
            name.id, //id thiet bi
            isQRCodeDevice ? dataUpdate.cell_id : dataUpdate.id,
            'imp',
            'iwh',
        ];
        let service = serviceList.openCellIOT;
        let inpuVal = [data.cabinet_cd, data.drawer_lc, data.cell_lc.row, data.cell_lc.column];
        if (data?.cabinet_type !== 'round') {
            service = serviceList.openCellIOT;
            inpuVal = [data.cabinet_cd, data.drawer_lc, data.cell_lc.row, data.cell_lc.column];
        } else {
            service = serviceList.openCellIOTCabinetV2;
            inpuVal = [data.cabinet_cd, data.drawer_lc, data.cell_lc.column, data.column];
        }
        sendRequest(service, inpuVal, openCellResult, true, timeOutFunctIOT, 40000, 0);
    };

    // region openCellResult
    const openCellResult = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisible(false);
        } else {
            // setVisible(false);
            setOpenCellFlag(false);
            // gọi api kiểm tra trạng thái ô sau 5s
            const input_param = reqInfoMap['input_param'];
            // setTimeout(() => {
            handleIntervalCheckStatusCell(input_param[0], input_param[1], input_param[2]);
            // }, 5000);
        }
    };
    // region getData
    const getData = useCallback(() => {
        if (getFlags) {
            return;
        }
        const InVal = [9999999999999999999, '', +params.idGroup];
        sendRequest(serviceList.getAllDeviceSp, InVal, getDataResult, true, timeOutFunctGet, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1);
        }
    };

    const timeOutFunctGet = (reqInfo) => {
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };
    // region closeCell
    const closeCell = () => {
        setActionDeviceOnline(true);
        clearIntervalCheckStatusCell();
        let inpuVal = [dataUpdate.cabinet_cd, dataUpdate.drawer_lc, dataUpdate.cell_lc.row, dataUpdate.cell_lc.column];
        let service = serviceList.closeCellIOT;
        if (typeCabinet !== 'round') {
            service = serviceList.closeCellIOT;
            inpuVal = [dataUpdate.cabinet_cd, dataUpdate.drawer_lc, dataUpdate.cell_lc.row, dataUpdate.cell_lc.column];
        } else {
            service = serviceList.closeCellIOTCabinetV2;
            inpuVal = [dataUpdate.cabinet_cd, dataUpdate.drawer_lc, dataUpdate.cell_lc.column, dataUpdate.column];
        }
        sendRequest(service, inpuVal, closeCellResult, true, timeOutFunctIOT, 40000, 0);
    };
    const closeCellResult = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            setVisible(!visible);
        }
        clearIntervalCheckStatusCell();
    };

    const timeOutFunctIOT = (reqInfo) => {
        setActionDeviceOnline(false);
        setOpenCellFlag(false);
        setVisible(false);
        actionRef.current = false;
        toast.error(t('error.time_out') + ': ' + 'IoT');
    };

    // region handleEdit
    const handleEdit = () => {
        if (actionRef.current) return;
        if (!dataUpdate.cabinet_id || !dataUpdate.drawer_id) return toast.error(t('error.system_error'));
        if (!name?.id || !quantity || Min === '' || Min === null || !Max) return toast.error(t('error.param'));
        setActionDeviceOnline(true);
        actionRef.current = true;

        let InVal = [
            +idPermission,
            dataUpdate.cabinet_id,
            dataUpdate.drawer_id,
            '',
            +Max,
            +Min,
            +quantity,
            name.id, //id thiet bi
            isQRCodeDevice ? dataUpdate.cell_id : dataUpdate.id,
            'imp',
            'iwh',
        ];
        sendRequest(serviceList.updatebox, InVal, actionResult, true, timeOutFunct, 40000);
    };
    const actionResult = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            closeCell();
            setVisible(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisible(false);
            closeCell();
            if (isReload && isQRCodeDevice) {
                fuctGet && fuctGet(deviceCD, cabinetCD);
            } else if (isReload) {
                fuctGet && fuctGet(idCabinet, idDrawer);
            }
        }
    };

    const timeOutFunct = (reqInfo) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        toast.error(t('error.time_out'));
    };

    const handleClose = () => {
        closeCell();
        // setVisible(!visible);
    };

    // region checkStatusCell START
    const checkIntervalCheckStatusCell = useRef(null);
    const checkStatusCellFlag = useRef(false);
    const handleIntervalCheckStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        checkIntervalCheckStatusCell.current = setInterval(() => {
            checkStatusCell(cabinet_cd, drawer_id, cell_address);
        }, 3000);
    };
    const clearIntervalCheckStatusCell = () => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        clearInterval(checkIntervalCheckStatusCell.current);
    };
    const checkStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        if (!cabinet_cd || !drawer_id || !cell_address || checkStatusCellFlag.current) return;
        checkStatusCellFlag.current = true;
        const inpuVal = [cabinet_cd, drawer_id, cell_address];
        sendRequest(
            serviceList.checkStatusCell,
            inpuVal,
            checkStatusCellResult,
            true,
            checkStatusCellTimeOut,
            40000,
            0
        );
    };
    const checkStatusCellResult = (reqInfoMap, message) => {
        checkStatusCellFlag.current = false;
        console.log(
            'checkStatusCellResult',
            (message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1'
        );
        if ((message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1') {
            closeCell();
        }
    };
    const checkStatusCellTimeOut = (reqInfo) => {
        checkStatusCellFlag.current = false;
    };
    // region checkStatusCell END
    return (
        <BootstrapDialog fullScreen={fullScreen} open={visible} aria-labelledby="customized-dialog-title">
            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                {typeCabinet === 'round'
                    ? `${t('import_device')} ${t('ordinal_number')}: [ ${dataUpdate?.cell_lc?.column} ]`
                    : `${t('import_device')} ${t('cell')}: [ ${dataUpdate?.cell_lc?.row} : ${
                          dataUpdate?.cell_lc?.column
                      } ]`}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <ConfirmDeviceModal
                    visible={visibleConfirm}
                    setVisible={setVisibleConfirm}
                    title={t('comfirm')}
                    handleSave={() => {
                        closeCell();
                    }}
                />
                <Alert sx={{ alignItems: 'flex-start' }} severity="warning" style={{ marginBottom: '20px' }}>
                    <div>
                        <Typography fontWeight="lg" sx={{ fontWeight: '600', fontSize: '17px' }} mt={0.25}>
                            {t('note')}
                        </Typography>
                        <Typography fontSize="sm" sx={{ opacity: 0.8 }}>
                            {t('modal_confirm')}
                            <b> {t('modal_tt')} </b>
                            {t('thanks_modal')}
                        </Typography>
                    </div>
                </Alert>
                <Loader loading={actionDeviceOnline} />
                <Grid container spacing={2}>
                    <Grid
                        style={{ width: '100%' }}
                        item
                        xl={name?.pic_device ? 8 : 12}
                        md={name?.pic_device ? 8 : 12}
                        sm={12}
                    >
                        {/* <ComboboxImage
                            label={t('choose_device')}
                            valueSelect={name}
                            getValue={setName}
                            disabled={dataUpdate?.qty > 0 ? true : false}
                            selectOption={tableData}
                            displayLabel="device_cd"
                            valueEqual="id"
                            required
                            autoFocus
                        /> */}
                        <ComboboxImageNameOrQR
                            label={t('choose_device')}
                            valueSelect={name}
                            getValue={setName}
                            disabled={dataUpdate?.qty > 0 ? true : false}
                            selectOption={tableData}
                            displayLabel="device_cd"
                            valueEqual="id"
                            required
                            autoFocus
                        />
                    </Grid>{' '}
                    {/* {name?.pic_device && (
                        <Grid style={{ width: '100%' }} item xl={4} md={4} sm={12}>
                            <Box sx={{ position: 'relative' }}>
                                <StyledProductImg
                                    alt={''}
                                    src={
                                        name?.pic_device
                                            ? `${glb_sv.urlGetProductImage(name.pic_device)}`
                                            : imgDefault
                                    }
                                />
                            </Box>
                        </Grid>
                    )} */}
                    {!name?.pic_device && !name?.img_device ? (
                        ' '
                    ) : (
                        <Grid style={{ width: '100%' }} item xl={4} md={4} sm={12}>
                            <Box sx={{ position: 'relative' }}>
                                <StyledProductImg
                                    alt={''}
                                    src={
                                        name?.img_device
                                            ? `${glb_sv.urlGetProductImage(name.img_device)}`
                                            : `${glb_sv.urlGetProductImage(name.pic_device)}`
                                    }
                                />
                            </Box>
                        </Grid>
                    )}
                    <Grid style={{ width: '100%' }} item xl={6} md={6} sm={6}>
                        <NumberInput
                            label={t('quanty_now')}
                            valueChange={dataUpdate?.qty ? dataUpdate.qty : 0}
                            disabled
                        />
                    </Grid>
                    <Grid style={{ width: '100%' }} item xl={6} md={6} sm={6}>
                        <NumberInput
                            label={t('quanty_import')}
                            valueChange={quantity}
                            required
                            autoFocus
                            getValue={setQuantity}
                        />
                    </Grid>
                    <Grid style={{ width: '100%' }} item xl={6} md={6} sm={6}>
                        <NumberInput
                            label={t('Min')}
                            valueChange={Min || Min === 0 ? Min : ''}
                            required
                            getValue={setMin}
                        />
                    </Grid>
                    <Grid style={{ width: '100%' }} item xl={6} md={6} sm={6}>
                        <NumberInput label={t('Max')} valueChange={Max ? Max : ''} required getValue={setMax} />
                    </Grid>
                    {dataUpdate?.cabinet_type !== 'round' && (
                        <ChessBoard
                            rows={dataUpdate?.row}
                            columns={dataUpdate?.column}
                            activePosition={{
                                row: dataUpdate?.cell_lc?.row ? dataUpdate.cell_lc.row : 1,
                                column: dataUpdate?.cell_lc?.column ? dataUpdate.cell_lc.column : 1,
                            }}
                            typeCabinet={typeCabinet}
                        />
                    )}
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction onClick={handleClose} type={'cancel'} title={t('cancel') + ' ' + t('import')} />
                <ButtonAction
                    disabled={openCellFlag}
                    onClick={handleEdit}
                    type={'save'}
                    title={t('comfirm') + ' ' + t('import')}
                />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default CellModal;
